import merge from 'lodash/merge';
import { es as esESAdapter, enUS as enUSAdapter } from 'date-fns/locale';

import { esES as esESCore, enUS as enUSCore } from '@mui/material/locale';
// date fns

import { esES as esESDataGrid, enUS as enUSDataGrid } from '@mui/x-data-grid';
// core (MUI)
// date pickers (MUI)
import { esES as esESDate, enUS as enUSDate } from '@mui/x-date-pickers/locales';
// data grid (MUI)

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
  },
  {
    label: 'Spanish',
    value: 'es',
    systemValue: merge(esESDate, esESDataGrid, esESCore),
    adapterLocale: esESAdapter,
    icon: 'flagpack:es',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
